import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const basename =
  process.env.PUBLIC_URL &&
  process.env.PUBLIC_URL !== '/' &&
  process.env.PUBLIC_URL !== '.'
    ? process.env.PUBLIC_URL.replace(/\/$/, '')
    : undefined;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <>
        <BrowserRouter basename={basename}>
            <App />
        </BrowserRouter>
 </>
);

